'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';

import Image from 'next/image';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

import type { GeneralLayout } from '@eliadmin/core/src/api/general/types/general-layout-types';

import { ROUTES } from '@eliadmin/core/src/constants/routes';
import { cn } from '@eliadmin/core/src/utils/style-utils';

const SAFETY_SHOWERS_SLUG = '/bezpecnostne-sprchy';

interface LogoProps {
  src?: string;
  alt?: string;
  generalLayout: GeneralLayout['data'];
  className: {
    link?: string;
    image: string;
  };
}

export function Logo({ src, alt, generalLayout, className }: LogoProps) {
  const pathname = usePathname();
  const isSafetyPage = pathname.includes(SAFETY_SHOWERS_SLUG);

  const resolvedSrc =
    src ||
    (isSafetyPage ? generalLayout?.footer?.logo?.url : generalLayout?.header?.logo?.url) ||
    '/placeholder.png';

  return (
    <Link
      prefetch={false}
      href={ROUTES.HOME()}
      className={cn('cursor-pointer transition-all ease-in-out hover:opacity-75', className?.link)}
    >
      <Image
        src={resolvedSrc}
        alt={
          typeof alt === 'string'
            ? alt
            : resolveImageAlt(
                src
                  ? undefined
                  : isSafetyPage
                    ? generalLayout?.footer?.logo
                    : generalLayout?.header?.logo,
                alt ?? (generalLayout?.site_name?.trim() || ''),
              )
        }
        width={200}
        height={60}
        className={cn('w-auto shrink-0 object-contain object-center', className?.image)}
        sizes="200px"
      />
    </Link>
  );
}
